<script>
	// Stores
	import { linkBoletoFacil } from '../store.js';
</script>

<span class="boletoFacil" style="position: fixed; left: 5px; z-index: 100; bottom: 5px; display: inline-block;">
	<a href="{$linkBoletoFacil}" target="_blank">
		<img src="assets/images/imgBoleto.png" alt="Boleto" style="border: 0px;" />
	</a>
</span>